module.exports = __webpack_public_path__ + "fonts/nunito-sans-v6-latin-800.6a4c29ad.woff2";